import { render, staticRenderFns } from "./FooterBlock.vue?vue&type=template&id=6dd7b2a8&"
import script from "./FooterBlock.vue?vue&type=script&lang=js&"
export * from "./FooterBlock.vue?vue&type=script&lang=js&"
import style0 from "./FooterBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports